// localStorage-backed session-token storage. v1 trade-off: simpler than
// cookies, fine for a personal-project surface. Upgrade to an httpOnly
// cookie if/when XSS becomes a realistic concern.

const KEY = "clubmanager_session";

export function getSessionToken(): string | null {
  return localStorage.getItem(KEY);
}

export function setSessionToken(token: string) {
  localStorage.setItem(KEY, token);
}

export function clearSessionToken() {
  localStorage.removeItem(KEY);
}
